import template from './insurance-state-list.html';
import controller from './insurance-state-list.controller';

let insuranceStateListComponent = {
  bindings: {},
  template,
  controller
};

export default insuranceStateListComponent;



// WEBPACK FOOTER //
// ./client/app/components/insurance/insurance-state-list.component.js